import View from '@/base/tables/view';

class RegisterActivity extends View {

    static table = 'registeractivity';

}

export default RegisterActivity;
